import { useCallback } from 'react'
import getBufferETAFlag from './getBufferETAFlag'
import { useShoppingCartContext } from '../components/ShoppingCartV2/providers/ShoppingCartProvider'
import shoppingCartV2API from '../components/ShoppingCartV2/api'
import nrLogger from './nrLogger'

const useUpdateCartItemsShippingDetails = () => {
  const {
    getIdentifier,
    getCartId,
    setCart,
    shouldShowLoader,
    setIsCartDataMerged,
  } = useShoppingCartContext()

  const buffereta = getBufferETAFlag()

  return useCallback(async (modifiers) => {
      try {
        const cartId = getCartId()
        if(cartId) {
          shouldShowLoader(true)
          const identifier = getIdentifier()
          const res = await shoppingCartV2API.items.updateShipping(identifier, cartId, modifiers, buffereta)
          setCart(res)
        }
      } catch (error) {
        nrLogger.error('ShoppingCartV2.useUpdateCartItemsShippingDetails.error', error)
        setIsCartDataMerged(true)
      }
      shouldShowLoader(false)
    },
    [
      shouldShowLoader,
      getCartId,
      getIdentifier,
      setCart,
      buffereta,
      setIsCartDataMerged,
    ],
  )
}

export default useUpdateCartItemsShippingDetails
